const AuroraStoreFrontServices = (function () {
  const settings = {
    name: "aurora-store-front-services.js",
    api_version: "2024-10",
    debugging: true,
  };

  const fetchStoreFront = (props) => {
    const { query, variables, publicAccessToken } = props;
    return fetch(`https://${Shopify?.shop}/api/${settings.api_version}/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": publicAccessToken,
      },
      body: JSON.stringify({ query, variables }),
    });
  };

  const getVariantNodesByIds = async (props = {}) => {
    const { variantIds = [], publicAccessToken } = props;

    if (!Array.isArray(variantIds) || variantIds.length === 0) {
      return [];
    }

    try {
      const response = await fetchStoreFront({
        query: `query BundleParentVariants($ids: [ID!]!) {
          nodes(ids: $ids) {
            ...on ProductVariant {
              id
              title
              image {
                url
                altText
              }
              product {
                id
                title
                handle
                tags
                featuredImage {
                  url
                  altText
                }
              }
            }
          }
        }`,
        variables: {
          ids: variantIds,
        },
        publicAccessToken,
      });
      const data = await response.json();
      const nodes = data?.data?.nodes;

      return Array.isArray(nodes) ? nodes : [];
    } catch (error) {
      console.error("Error fetching variant nodes:", error);
      return [];
    }
  };

  return {
    fetchStoreFront,
    getVariantNodesByIds,
  };
})();
